import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
//const { createWorker, createScheduler } = require('tesseract.js');
 //import * as pdfjsLib from 'pdfjs-dist/build/pdf.js';
@Component({
    selector: 'app-tesseract',
    templateUrl: './tesseract.component.html',
    styleUrls: ['./tesseract.component.scss'],
    standalone: false
})
export class TesseractComponent implements OnInit {
  title = 'Read text from image or PDF';
  ocrResult = 'Recognizing...';
  capturePregress = 0;
  workerReady = false;
  capturingStarted = false;
  isDisabled: boolean;
  fileToProcess: File = null;
  parsedData: any = null;  // Store the parsed JSON-like object


  @ViewChild("showProgress") showProgress: ElementRef;

  constructor(public loader: LoaderService) { }

  ngOnInit(): void {
  //   if (!pdfjsLib.GlobalWorkerOptions.workerSrc) {
  //     const WORKER_URL = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
  //     pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_URL;
  // }
  }

  // Called when the user selects a file
  onFileChange(event: any) {
    this.fileToProcess = event.target.files[0];
  }

  // // Triggers the OCR process
  // captureText() {
  //   if (this.fileToProcess) {
  //     const fileType = this.fileToProcess.type;
  //     if (fileType === 'application/pdf') {
  //       this.extractTextFromPDF();
  //     } else if (fileType.startsWith('image/')) {
  //       this.extractTextFromImage();
  //     } else {
  //       this.ocrResult = 'Unsupported file type. Please upload a PDF or image.';
  //     }
  //   }
  //   this.capturingStarted = true;
  //   this.ocrResult = 'Recognizing...';
  //   this.workerReady =true;
  // }

  // // OCR for image files
  // async extractTextFromImage() {
  //   this.isDisabled = true;
  //   const worker = await createWorker('eng', 1, {
  //     logger: progress => {
  //       if (progress && progress.status == 'recognizing text') {
  //         console.log("data is", progress);
  //         this.capturePregress = parseInt('' + progress.progress * 100);
  //         this.showProgress.nativeElement.innerHTML = `<b>In-Progress </b> : <b>${this.capturePregress} % </b>`;
  //       } }
  //   });

  //   await worker.load();
  //   const imageUrl = URL.createObjectURL(this.fileToProcess);
  //   const { data: { text } } = await worker.recognize(imageUrl);
  //   this.ocrResult = text;
  //   this.parsedData = this.parseTextToJson(text);  // Parse the OCR result into JSON
  //   console.log("Extracted text from image:", text);
  //   console.log("Parsed JSON data:", this.parsedData);
  //   this.isDisabled = false;
  //   await worker.terminate();
  // }

  // // OCR for PDF files
  // async extractTextFromPDF() {
  //   this.isDisabled = true;
  //   const fileReader = new FileReader();
  //   fileReader.onload = async () => {
  //     const typedArray = new Uint8Array(fileReader.result as ArrayBuffer);
  //     const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;

  //     let fullText = '';

  //     for (let i = 0; i < pdf.numPages; i++) {
  //       const page = await pdf.getPage(i + 1);
  //       const viewport = page.getViewport({ scale: 1.5 });
  //       const canvas = document.createElement('canvas');
  //       const context = canvas.getContext('2d');
  //       canvas.height = viewport.height;
  //       canvas.width = viewport.width;
  //       const renderContext = { canvasContext: context, viewport: viewport };
  //       await page.render(renderContext).promise;

  //       const imageDataUrl = canvas.toDataURL();
  //       const worker = await createWorker('eng', 1, {
  //         logger: progress => {
  //           if (progress && progress.status == 'recognizing text') {
  //             console.log("data is", progress);
  //             this.capturePregress = parseInt('' + progress.progress * 100);
  //             this.showProgress.nativeElement.innerHTML = `<b>In-Progress </b> : <b>${this.capturePregress} % </b>`;
  //           } }
  //       });
       
  //       await worker.load();
  //       const { data: { text } } = await worker.recognize(imageDataUrl);
  //       fullText += text;
  //       await worker.terminate();
  //     }

  //     this.ocrResult = fullText;
  //     this.parsedData = this.parseTextToJson(fullText);  // Parse the OCR result into JSON
  //     console.log("Extracted text from PDF:", fullText);
  //     console.log("Parsed JSON data:", this.parsedData);
  //     this.isDisabled = false;
  //   };
  //   fileReader.readAsArrayBuffer(this.fileToProcess);
  // }

  // // Parse recognized text to JSON
  // parseTextToJson(text: string): any {
  //   const lines = text.split('\n').map(line => line.trim()).filter(line => line !== '');

  //   // Example logic for handling tabular data (adjust this based on your specific needs)
  //   let jsonResult = {};
  //   lines.forEach(line => {
  //     const columns = line.split(/\s+/);  // Assuming spaces separate columns
  //     if (columns.length === 2) {  // Example: for form data with key-value pairs
  //       jsonResult[columns[0]] = columns[1];
  //     }
  //   });

  //   return jsonResult;
  // }
}
